import { Box } from "@mui/material";
import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: calc(100vh - 300px);
`;

export const ContentContainer = styled.div`
  flex: 1;
  overflow: auto;
  min-height: 0;
`;

export const TableContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .MuiPaper-root {
    display: flex;
    flex-direction: column;
  }

  .MuiTableContainer-root {
    border-bottom: none;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.columns && typeof props.columns === "number" && props.columns > 0
      ? `repeat(${props.columns}, minmax(200px, 1fr))`
      : "repeat(auto-fill, minmax(200px, 1fr))"};
  gap: 1rem;
  width: 100%;

  @media (max-width: 1920px) {
    grid-template-columns: ${(props) =>
      props.columns > 6 ? 'repeat(6, minmax(200px, 1fr))' : `repeat(${props.columns}, minmax(200px, 1fr))`};
  }

  @media (max-width: 1440px) {
    grid-template-columns: ${(props) =>
      props.columns > 4 ? 'repeat(4, minmax(200px, 1fr))' : `repeat(${props.columns}, minmax(200px, 1fr))`};
  }

  @media (max-width: 1024px) {
    grid-template-columns: ${(props) =>
      props.columns > 3 ? 'repeat(3, minmax(200px, 1fr))' : `repeat(${props.columns}, minmax(200px, 1fr))`};
  }

  @media (max-width: 768px) {
    grid-template-columns: ${(props) =>
      props.columns > 2 ? 'repeat(2, minmax(150px, 1fr))' : `repeat(${props.columns}, minmax(150px, 1fr))`};
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const GridViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.gray3};
`;
